export default "assets/images/stries-circle-24d52d70.svg";